var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafewallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17956",
    "data-name": "Group 17956",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.706,
    height: 51.706,
    viewBox: "0 0 51.706 51.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Lock_Money_Wallet_Icon",
    "data-name": "Lock, Money, Wallet Icon",
    d: "M48.166,9.387H44.473V7.54A5.54,5.54,0,0,0,38.933,2H7.54A5.54,5.54,0,0,0,2,7.54V42.626a5.54,5.54,0,0,0,5.54,5.54,1.847,1.847,0,0,0,0-3.693,1.847,1.847,0,0,1-1.847-1.847V12.747a5.54,5.54,0,0,0,1.847.332H48.166a1.847,1.847,0,0,1,1.847,1.847v1.847H37.086a5.54,5.54,0,1,0,0,11.08H50.013V42.626a1.847,1.847,0,0,1-1.847,1.847H35.24a1.847,1.847,0,0,0,0,3.693H48.166a5.54,5.54,0,0,0,5.54-5.54v-27.7A5.54,5.54,0,0,0,48.166,9.387ZM5.693,7.54A1.847,1.847,0,0,1,7.54,5.693H38.933A1.847,1.847,0,0,1,40.78,7.54V9.387H7.54A1.847,1.847,0,0,1,5.693,7.54ZM37.086,24.16a1.847,1.847,0,1,1,0-3.693H50.013V24.16Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Lock_Money_Wallet_Icon-2",
    "data-name": "Lock, Money, Wallet Icon",
    d: "M27.853,37.289V34.556a6.722,6.722,0,0,0-6.463-6.943,6.722,6.722,0,0,0-6.463,6.943v2.733s-3.693,2.77-3.693,5.337v5.54a5.54,5.54,0,0,0,5.54,5.54h9.233a5.54,5.54,0,0,0,5.54-5.54v-5.54C31.546,40.041,27.853,37.289,27.853,37.289ZM21.39,31.546c1.274,0,2.308,1.237,2.77,2.77v2.77H18.62v-2.77C19.081,32.784,20.116,31.546,21.39,31.546Zm6.463,16.62a1.847,1.847,0,0,1-1.847,1.847H16.773a1.847,1.847,0,0,1-1.847-1.847v-5.54a1.847,1.847,0,0,1,1.847-1.847h9.233a1.847,1.847,0,0,1,1.847,1.847Z",
    transform: "translate(-2 -2)",
    fill: "#d7df23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafewallet);
export default __webpack_public_path__ + "static/media/safewallet.f4a63aaeb240678efbe2dd3725713289.svg";
export { ForwardRef as ReactComponent };